var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._g(_vm._b({staticClass:"tamara-base-input",scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_vm._t("prefix")]},proxy:true},{key:"suffix",fn:function(){return [_vm._t("suffix")]},proxy:true}],null,true)},'el-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }